import { ActionTypes } from '../constants';

export const getBlogs = (page = 0, size = 10, sort = 'lastModifiedAt,desc') => ({
  type: ActionTypes.GET_BLOGS_LIST_REQUEST,
  requestConfig: {
    page,
    size,
    sort,
  }
});

export const getBlogById = (id) => ({
  type: ActionTypes.GET_BLOG_BY_ID_REQUEST,
  requestConfig: {
    id
  }
});

export const getBlogBySlug = (slug) => ({
  type: ActionTypes.GET_BLOG_BY_SLUG_REQUEST,
  requestConfig: {
    slug
  }
});

export const createBlog = (values) => ({
  type: ActionTypes.CREATE_BLOG_REQUEST,
  requestConfig: values,
    onSuccessActions: {
    type: ActionTypes.GET_BLOGS_LIST_REQUEST,
    requestConfig: { page: 0, size: 10, sort: 'lastModifiedAt,desc' }
  }
});

export const uploadImage = (file, onSuccess, onFailure, fileType = 'BLOG_IMAGE') => ({
  type: ActionTypes.UPLOAD_BLOG_IMAGE_REQUEST,
  requestConfig: {
    file,
    fileType,
  },
  dispatchCallBack: {
    onSuccess,
    onFailure,
  },
});

export const updateBlog = (id, values, page) => ({
  type: ActionTypes.UPDATE_BLOG_REQUEST,
  requestConfig: {
    id,
    ...values
  },
    onSuccessActions: {
    type: ActionTypes.GET_BLOGS_LIST_REQUEST,
    requestConfig: { page: 0, size: 10, sort: 'lastModifiedAt,desc' }
  }
});

export const deleteBlog = (id, page) => ({
  type: ActionTypes.DELETE_BLOG_REQUEST,
  requestConfig: {
    id
  }
});

export const searchBlogs = (query, page = 0) => ({
  type: ActionTypes.SEARCH_BLOGS_REQUEST,
  requestConfig: {
    query,
    page,
    size: 20,
    sort: 'lastModifiedAt,desc'
  }
});

export const clearCurrentBlog = () => ({
  type: ActionTypes.CLEAR_CURRENT_BLOG
});

export const clearBlogsList = () => ({
  type: ActionTypes.CLEAR_BLOGS_LIST
});

